// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.w-70 {
  width: 70px;
}

.w-400 {
  width: 400px;
}

.form_group_modal {
  width: 100%;
  margin-bottom: 0;
}

::ng-deep .popover-body {
  height: 80px !important;
}

.form_group_modal textarea {
  border: #e6e6ff solid 1px;
  border-radius: 5px;
  opacity: 0.9;
  height: 100px;
  width: 100%;
  padding: 10px 20px;
  margin-bottom: 15px;
  resize: vertical;
}

.form_group_modal select {
  border: #e6e6ff solid 1px;
  border-radius: 5px;
  opacity: 0.9;
  width: 100%;
  margin-bottom: 15px;
  font-size: 15px;
}

.form_group_modal input {
  width: 100%;
}

.badge a {
  color: #fff;
}

.primary {
  background-color: #337ab7;
  border-color: #2e6da4;
}

.danger {
  background-color: #d9534f;
  border-color: #d43f3a;
}

.danger-dark {
  background-color: #9a2421;
  border-color: #844e4d;
}

.text-white {
  color: #fff;
}

.label_title {
  width: 100%;
}

.w-85 {
  width: 85%;
}

.m-20 {
  margin: 20px;
}

.box {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.gallery-image {
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.gallery-image img {
  height: 250px;
  width: 360px;
  transform: scale(1);
  transition: transform 0.4s ease;
}

.img-box {
  box-sizing: content-box;
  margin: 10px;
  height: 250px;
  width: 360px;
  overflow: hidden;
  display: inline-block;
  color: white;
  position: relative;
  background-color: white;
}

.caption {
  position: absolute;
  bottom: 5px;
  left: 20px;
  opacity: 0;
  color: #fff !important;
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.caption-check {
  position: absolute;
  top: 20px;
  right: 20px;
  opacity: 0;
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.transparent-box {
  height: 250px;
  width: 360px;
  background-color: rgba(0, 0, 0, 0);
  position: absolute;
  top: 0;
  left: 0;
  transition: background-color 0.3s ease;
}

.img-box:hover img {
  transform: scale(1.1);
}

.img-box:hover .transparent-box {
  background-color: rgba(0, 0, 0, 0.5);
}

.img-box:hover .caption {
  transform: translateY(-20px);
  opacity: 1;
}

.img-box:hover .caption-check {
  transform: translateY(20px);
  opacity: 1;
}

.caption > p:nth-child(2) {
  font-size: 0.8em;
}

.caption-check > p:nth-child(2) {
  font-size: 1.8em;
}

.opacity-low {
  opacity: 0.5;
  color: #fff;
}

.text-white {
  color: #fff;
}

.box-style {
  max-height: 300px;
  overflow-y: auto;
  box-shadow: 0 0 8px 1px #79797b;
  padding: 20px;
}

@media only screen and (max-width: 768px) {
  .modal-right-overlay {
    display: none;
  }
  .hide_data {
    display: none;
  }
}
@media (min-width: 992px) and (min-width: 1200px) {
  .tabletMode {
    display: none;
  }
}
@media (max-width: 1199px) {
  .modal-right-overlay {
    display: none;
  }
}
@media (max-width: 1396px) {
  .modal-lg {
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
    align-items: center;
  }
}
.modal-right-overlay {
  position: fixed;
  background-color: #efefef;
  width: 42%;
  padding: 20px;
  border: 1px solid rgba(20, 21, 22, 0.2);
  border-radius: 0.3rem;
  height: 730px;
  overflow-y: auto;
}

.script-title {
  color: #fe5723;
  font-size: 22px;
  padding-top: 20px;
  margin-bottom: 60px;
}

.p-t-60 {
  padding-top: 60px;
}

.sub-title {
  padding-bottom: 30px;
  font-weight: 700px;
}

.detail-container {
  background-color: white;
  color: black;
  padding: 20px 10px 50px 10px;
  border-radius: 5px;
}

.detail-container-small {
  background-color: white;
  color: black;
  margin-top: 60px;
  border-radius: 5px;
}

.border {
  border: 1px #f4e8e8 solid;
}

.button {
  padding: calc(0.875rem - 1px) calc(1.5rem - 1px);
  box-shadow: rgba(0, 0, 0, 0.02) 0 1px 3px 0;
  text-align: center;
  cursor: pointer;
  touch-action: manipulation;
  vertical-align: baseline;
  transition: all 250ms;
  border-radius: 0.25rem;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  box-sizing: border-box;
  border: 1px solid transparent;
  width: auto;
}
.button.previous {
  background-color: white;
  color: black;
  border: 2px solid #c2c2c2;
}
.button.next {
  background-color: #fe5723;
  color: white;
  padding-left: 20px;
}

.disabled-button-next {
  cursor: not-allowed;
}

.disabled-button-previous {
  cursor: not-allowed;
}

.note {
  padding-top: 15px;
  font-weight: 700;
  padding-bottom: 20px;
}

.next-button:hover,
.next-button:focus {
  background-color: #fb8332;
  box-shadow: rgba(0, 0, 0, 0.1) 0 4px 12px;
}

.next-button:hover {
  transform: translateY(-1px);
}

.next-button:active {
  background-color: #c85000;
  box-shadow: rgba(0, 0, 0, 0.06) 0 2px 4px;
  transform: translateY(0);
}

.score-field {
  padding-top: 10px;
  padding-bottom: 20px;
  color: #fe5723;
  font-weight: 700px;
}

.description {
  font-style: italic;
  color: #101011;
}

.question {
  padding-top: 20px;
  padding-right: 20px;
}

.error-message {
  color: #fe5723;
}

.index {
  color: #fe5723;
}
.index span {
  color: black;
}

.first {
  background-color: pink;
  height: 50%;
  width: 40px;
}

.blank-input {
  border: none;
  background-color: transparent;
  outline: none;
  padding-left: 20px;
}

.result {
  background: #ffd200;
  border-radius: 10px;
  color: white;
  padding: 20px 45px 10px 45px;
  text-align: center;
}

.number {
  font-size: 40px;
}

.last-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
}

.ending {
  text-align: center;
  margin-top: 20px;
}

.content {
  white-space: pre-line;
}

.centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  overflow-y: auto;
  max-height: 80%;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/containers/crm/shared/kyc-shared-modal/kyc-shared-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AACA;EACE,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;AAEF;;AACA;EACE,WAAA;AAEF;;AAEE;EACE,WAAA;AACJ;;AAGA;EACE,yBAAA;EACA,qBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,qBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,qBAAA;AAAF;;AAGA;EACE,WAAA;AAAF;;AAGA;EACE,WAAA;AAAF;;AAGA;EACE,UAAA;AAAF;;AAGA;EACE,YAAA;AAAF;;AAGA;EACE,sBAAA;EACA,SAAA;EACA,UAAA;AAAF;;AAGA;EACE,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;AAAF;;AAGA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,+BAAA;AAAF;;AAGA;EACE,uBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;EACA,sBAAA;EACA,kDAAA;AAAF;;AAGA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,kDAAA;AAAF;;AAGA;EACE,aAAA;EACA,YAAA;EACA,kCAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,sCAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,oCAAA;AAAF;;AAGA;EACE,4BAAA;EACA,UAAA;AAAF;;AAGA;EACE,2BAAA;EACA,UAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,YAAA;EACA,WAAA;AAAF;;AAGA;EACE,WAAA;AAAF;;AAOA;EACE,iBAAA;EACA,gBAAA;EACA,+BAAA;EACA,aAAA;AAJF;;AAOA;EACE;IACE,aAAA;EAJF;EAMA;IACE,aAAA;EAJF;AACF;AAOA;EACE;IACE,aAAA;EALF;AACF;AAQA;EACE;IACE,aAAA;EANF;AACF;AASA;EACE;IACE,eAAA;IACA,iBAAA;IACA,kBAAA;IACA,mBAAA;EAPF;AACF;AASA;EACE,eAAA;EACA,yBAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;EACA,qBAAA;EACA,aAAA;EACA,gBAAA;AAPF;;AAUA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAPF;;AASA;EACE,iBAAA;AANF;;AAQA;EACE,oBAAA;EACA,kBAAA;AALF;;AAOA;EACE,uBAAA;EACA,YAAA;EACA,4BAAA;EACA,kBAAA;AAJF;;AAOA;EACE,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AAJF;;AAOA;EACE,yBAAA;AAJF;;AAOA;EACE,gDAAA;EAGA,2CAAA;EACA,kBAAA;EACA,eAAA;EACA,0BAAA;EACA,wBAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,6BAAA;EACA,WAAA;AANF;AAOE;EACE,uBAAA;EACA,YAAA;EACA,yBAAA;AALJ;AAOE;EACE,yBAAA;EACA,YAAA;EACA,kBAAA;AALJ;;AAQA;EACE,mBAAA;AALF;;AAOA;EACE,mBAAA;AAJF;;AAMA;EACE,iBAAA;EACA,gBAAA;EACA,oBAAA;AAHF;;AAKA;;EAEE,yBAAA;EACA,yCAAA;AAFF;;AAIA;EACE,2BAAA;AADF;;AAGA;EACE,yBAAA;EACA,yCAAA;EACA,wBAAA;AAAF;;AAGA;EACE,iBAAA;EACA,oBAAA;EACA,cAAA;EACA,kBAAA;AAAF;;AAEA;EACE,kBAAA;EACA,cAAA;AACF;;AACA;EACE,iBAAA;EACA,mBAAA;AAEF;;AAAA;EACE,cAAA;AAGF;;AADA;EACE,cAAA;AAIF;AAFE;EACE,YAAA;AAIJ;;AADA;EACE,sBAAA;EACA,WAAA;EACA,WAAA;AAIF;;AADA;EACE,YAAA;EACA,6BAAA;EACA,aAAA;EACA,kBAAA;AAIF;;AAFA;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,4BAAA;EACA,kBAAA;AAKF;;AAHA;EACE,eAAA;AAMF;;AAHA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,qBAAA;AAMF;;AAJA;EACE,kBAAA;EACA,gBAAA;AAOF;;AALA;EACE,qBAAA;AAQF;;AALA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;AAQF;AACA,wwXAAwwX","sourcesContent":[".w-70 {\n  width: 70px;\n}\n\n.w-400 {\n  width: 400px;\n}\n\n.form_group_modal {\n  width: 100%;\n  margin-bottom: 0;\n}\n\n::ng-deep .popover-body {\n  height: 80px !important;\n}\n\n.form_group_modal textarea {\n  border: #e6e6ff solid 1px;\n  border-radius: 5px;\n  opacity: 0.9;\n  height: 100px;\n  width: 100%;\n  padding: 10px 20px;\n  margin-bottom: 15px;\n  resize: vertical;\n}\n.form_group_modal select {\n  border: #e6e6ff solid 1px;\n  border-radius: 5px;\n  opacity: 0.9;\n  width: 100%;\n  margin-bottom: 15px;\n  font-size: 15px;\n}\n\n.form_group_modal input {\n  width: 100%;\n}\n\n.badge {\n  a {\n    color: #fff;\n  }\n}\n\n.primary {\n  background-color: #337ab7;\n  border-color: #2e6da4;\n}\n\n.danger {\n  background-color: #d9534f;\n  border-color: #d43f3a;\n}\n\n.danger-dark {\n  background-color: #9a2421;\n  border-color: #844e4d;\n}\n\n.text-white {\n  color: #fff;\n}\n\n.label_title {\n  width: 100%;\n}\n\n.w-85 {\n  width: 85%;\n}\n\n.m-20 {\n  margin: 20px;\n}\n\n.box {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n.gallery-image {\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.gallery-image img {\n  height: 250px;\n  width: 360px;\n  transform: scale(1);\n  transition: transform 0.4s ease;\n}\n\n.img-box {\n  box-sizing: content-box;\n  margin: 10px;\n  height: 250px;\n  width: 360px;\n  overflow: hidden;\n  display: inline-block;\n  color: white;\n  position: relative;\n  background-color: white;\n}\n\n.caption {\n  position: absolute;\n  bottom: 5px;\n  left: 20px;\n  opacity: 0;\n  color: #fff !important;\n  transition: transform 0.3s ease, opacity 0.3s ease;\n}\n\n.caption-check {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  opacity: 0;\n  transition: transform 0.3s ease, opacity 0.3s ease;\n}\n\n.transparent-box {\n  height: 250px;\n  width: 360px;\n  background-color: rgba(0, 0, 0, 0);\n  position: absolute;\n  top: 0;\n  left: 0;\n  transition: background-color 0.3s ease;\n}\n\n.img-box:hover img {\n  transform: scale(1.1);\n}\n\n.img-box:hover .transparent-box {\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n.img-box:hover .caption {\n  transform: translateY(-20px);\n  opacity: 1;\n}\n\n.img-box:hover .caption-check {\n  transform: translateY(20px);\n  opacity: 1;\n}\n\n.caption > p:nth-child(2) {\n  font-size: 0.8em;\n}\n\n.caption-check > p:nth-child(2) {\n  font-size: 1.8em;\n}\n\n.opacity-low {\n  opacity: 0.5;\n  color: #fff;\n}\n\n.text-white {\n  color: #fff;\n}\n\n::ng-deep .modal-content {\n  // left: -170px!important;\n}\n\n.box-style {\n  max-height: 300px;\n  overflow-y: auto;\n  box-shadow: 0 0 8px 1px #79797b;\n  padding: 20px;\n}\n\n@media only screen and (max-width: 768px) {\n  .modal-right-overlay {\n    display: none;\n  }\n  .hide_data {\n    display: none;\n  }\n}\n\n@media (min-width: 992px) and (min-width: 1200px) {\n  .tabletMode {\n    display: none;\n  }\n}\n\n@media (max-width: 1199px) {\n  .modal-right-overlay {\n    display: none;\n  }\n}\n\n@media (max-width: 1396px) {\n  .modal-lg {\n    max-width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n    align-items: center;\n  }\n}\n.modal-right-overlay {\n  position: fixed;\n  background-color: #efefef;\n  width: 42%;\n  padding: 20px;\n  border: 1px solid rgba(20, 21, 22, 0.2);\n  border-radius: 0.3rem;\n  height: 730px;\n  overflow-y: auto;\n}\n\n.script-title {\n  color: #fe5723;\n  font-size: 22px;\n  padding-top: 20px;\n  margin-bottom: 60px;\n}\n.p-t-60{\n  padding-top: 60px;\n}\n.sub-title {\n  padding-bottom: 30px;\n  font-weight: 700px;\n}\n.detail-container {\n  background-color: white;\n  color: black;\n  padding: 20px 10px 50px 10px;\n  border-radius: 5px;\n}\n\n.detail-container-small {\n  background-color: white;\n  color: black;\n  margin-top: 60px;\n  border-radius: 5px;\n}\n\n.border{\n  border: 1px #f4e8e8 solid;\n}\n\n.button {\n  padding: calc(0.875rem - 1px) calc(1.5rem - 1px);\n  // margin-top: 40px;\n  // margin-right: 20px;\n  box-shadow: rgba(0, 0, 0, 0.02) 0 1px 3px 0;\n  text-align: center;\n  cursor: pointer;\n  touch-action: manipulation;\n  vertical-align: baseline;\n  transition: all 250ms;\n  border-radius: 0.25rem;\n  font-size: 16px;\n  font-weight: 600;\n  text-decoration: none;\n  box-sizing: border-box;\n  border: 1px solid transparent;\n  width: auto;\n  &.previous {\n    background-color: white;\n    color: black;\n    border: 2px solid #c2c2c2;\n  }\n  &.next {\n    background-color: #fe5723;\n    color: white;\n    padding-left: 20px;\n  }\n}\n.disabled-button-next {\n  cursor: not-allowed;\n}\n.disabled-button-previous {\n  cursor: not-allowed;\n}\n.note {\n  padding-top: 15px;\n  font-weight: 700;\n  padding-bottom: 20px;\n}\n.next-button:hover,\n.next-button:focus {\n  background-color: #fb8332;\n  box-shadow: rgba(0, 0, 0, 0.1) 0 4px 12px;\n}\n.next-button:hover {\n  transform: translateY(-1px);\n}\n.next-button:active {\n  background-color: #c85000;\n  box-shadow: rgba(0, 0, 0, 0.06) 0 2px 4px;\n  transform: translateY(0);\n}\n\n.score-field {\n  padding-top: 10px;\n  padding-bottom: 20px;\n  color: #fe5723;\n  font-weight: 700px;\n}\n.description {\n  font-style: italic;\n  color: #101011;\n}\n.question {\n  padding-top: 20px;\n  padding-right: 20px;\n}\n.error-message {\n  color: #fe5723;\n}\n.index {\n  color: #fe5723;\n\n  span {\n    color: black;\n  }\n}\n.first {\n  background-color: pink;\n  height: 50%;\n  width: 40px;\n}\n\n.blank-input {\n  border: none;\n  background-color: transparent;\n  outline: none;\n  padding-left: 20px;\n}\n.result {\n  background: #ffd200;\n  border-radius: 10px;\n  color: white;\n  padding: 20px 45px 10px 45px;\n  text-align: center;\n}\n.number {\n  font-size: 40px;\n}\n\n.last-page {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  align-content: center;\n}\n.ending {\n  text-align: center;\n  margin-top: 20px;\n}\n.content {\n  white-space: pre-line;\n}\n\n.centered {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: white;\n  overflow-y: auto;\n  max-height: 80%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
